function getElm(data: {
  tag       : string, 
  id        : string, 
  hidden    : boolean,
  className : string,
}): [HTMLElement, boolean] {

  let elm: HTMLElement = null;
  let isNew = false;
  if (data.id) {
    elm = document.getElementById(data.id);
  };
  if (!elm) {
    elm = document.createElement(data.tag);
    isNew = true;
  } 

  if (data.id)          elm.id          = data.id;
  if (data.className)   elm.className   = data.className;

  if (data.hidden === true) {
    elm.classList.add('hidden');
  }
  if (data.hidden === false) {
    elm.classList.remove('hidden');
  }


  return [elm, isNew];
}


function getSvgElm(data: {
  tag     : string,
  id      : string,
  classes : string[],
  parent  : Node,
}): SVGElement {

  let elm: SVGElement;
  let isNew = false;
  elm = document.getElementById(data.id) as unknown as SVGElement;
  if (!elm) {
    elm = document.createElementNS("http://www.w3.org/2000/svg", data.tag);
    isNew = true;
  }
  elm.id = data.id;

  if (data.classes.length > 0) elm.classList.add(...data.classes);

  if (isNew) data.parent.appendChild(elm);

  return elm;
}


export function svg(data: {
  parent    : HTMLElement,
  id        : string,
  classes   : string[],
  viewbox   : string,
}): SVGSVGElement {

  const elm = getSvgElm({
    tag       : 'svg', 
    id        : data.id, 
    classes   : data.classes,
    parent    : data.parent,
  }) as SVGSVGElement;

  if (data.viewbox) elm.setAttribute('viewbox', data.viewbox);
  
  return elm;
}


export function rect(data: {
  parent    : SVGElement,
  id        : string,
  classes   : string[],
  x         : string,
  y         : string,
  ry        : string,
}): SVGRectElement {

  const elm = getSvgElm({
    tag       : 'rect', 
    id        : data.id, 
    classes   : data.classes,
    parent    : data.parent,
  }) as SVGRectElement;

  if (data.x)  elm.setAttribute('x', data.x);
  if (data.y)  elm.setAttribute('y', data.y);
  if (data.ry) elm.setAttribute('ry', data.ry);

  return elm;
}


export function path(data: {
  parent    : SVGElement,
  id        : string,
  classes   : string[],
  d         : string,
}): SVGPathElement {

  const elm = getSvgElm({
    tag       : 'path', 
    id        : data.id, 
    classes   : data.classes,
    parent    : data.parent,
  }) as SVGPathElement;

  if (data.d)  elm.setAttribute('d', data.d);

  return elm;
}


export function input(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  type        ?: 'hidden' |'file' | 'text' | 'checkbox',
  name        ?: string,
  value       ?: string,
  checked     ?: boolean,
  placeholder ?: string,
  maxLength   ?: string,
  hidden      ?: boolean,

}): HTMLInputElement {

  const [elm, isNew] = getElm({
    tag       : 'input', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLInputElement, boolean];

  if (data.type        !== undefined) elm.type        = data.type;
  if (data.name        !== undefined) elm.name        = data.name;
  if (data.value       !== undefined) elm.value       = data.value;
  if (data.checked     !== undefined) elm.checked     = data.checked;
  if (data.innerHTML   !== undefined) elm.innerHTML   = data.innerHTML;
  if (data.placeholder !== undefined) elm.placeholder = data.placeholder;
  if (data.maxLength   !== undefined) elm.maxLength   = Number(data.maxLength);

  if (isNew) data.parent.appendChild(elm);
  return elm;
}


export function button(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  type        ?: 'button',
  name        ?: string,
  value       ?: string,
  hidden      ?: boolean,

}): HTMLButtonElement {
 
  const [elm, isNew] = getElm({
    tag       : 'button', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLButtonElement, boolean];

  if (data.type      !== undefined) elm.type        = data.type;
  if (data.name      !== undefined) elm.name        = data.name;
  if (data.value     !== undefined) elm.value       = data.value;
  if (data.innerHTML !== undefined) elm.innerHTML   = data.innerHTML;

  if (isNew) data.parent.appendChild(elm);
  return elm;
}


export function label(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  htmlFor     ?: string,
  hidden      ?: boolean,

}): HTMLLabelElement {
 
  const [elm, isNew] = getElm({
    tag       : 'label', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLLabelElement, boolean];

  if (data.htmlFor   !== undefined) elm.htmlFor     = data.htmlFor;
  if (data.innerHTML !== undefined) elm.innerHTML   = data.innerHTML;

  if (isNew) data.parent.appendChild(elm);
  return elm;
}


export function div(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  for         ?: string,
  name        ?: string,
  value       ?: string,
  hidden      ?: boolean,

}): HTMLDivElement {

  const [elm, isNew] = getElm({
    tag       : 'div', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLDivElement, boolean];

  if (data.innerHTML !== undefined) elm.innerHTML   = data.innerHTML;

  if (isNew) data.parent.appendChild(elm);
  return elm;
}


export function img(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  src         ?: string,
  alt         ?: string,
  hidden      ?: boolean,

}): HTMLImageElement {
 
  const [elm, isNew] = getElm({
    tag       : 'img', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLImageElement, boolean];

  if (data.src !== undefined) elm.src         = data.src;
  if (data.alt !== undefined) elm.alt         = data.alt;

  if (isNew) data.parent.appendChild(elm);
  return elm;
}

export function video(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  src         ?: string,
  hidden      ?: boolean,

}): HTMLVideoElement {

  const [elm, isNew] = getElm({
    tag       : 'video', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLVideoElement, boolean];
  
  if (data.innerHTML !== undefined) elm.innerHTML   = data.innerHTML;
  if (data.src       !== undefined) elm.src         = data.src;

  if (isNew) data.parent.appendChild(elm);
  return elm;
}


export function textarea(data: {
  parent       : HTMLElement,
  id          ?: string,
  className   ?: string,
  innerHTML   ?: string,
  name        ?: string,
  value       ?: string,
  placeholder ?: string,
  rows        ?: string,
  maxLength   ?: string,
  hidden      ?: boolean,

}): HTMLTextAreaElement {

  const [elm, isNew] = getElm({
    tag       : 'textarea', 
    id        : data.id, 
    hidden    : data.hidden,
    className : data.className
  }) as [HTMLTextAreaElement, boolean];
  
  if (data.name        !== undefined) elm.name        = data.name;
  if (data.value       !== undefined) elm.value       = data.value;
  if (data.innerHTML   !== undefined) elm.innerHTML   = data.innerHTML;
  if (data.placeholder !== undefined) elm.placeholder = data.placeholder;
  if (data.rows        !== undefined) elm.rows        = Number(data.rows);
  if (data.maxLength   !== undefined) elm.maxLength   = Number(data.maxLength);

  if (isNew) data.parent.appendChild(elm);
  return elm;
}
